module.exports = __webpack_public_path__ + "img/baby_eat.45d13756.png";